import { render, staticRenderFns } from "./newReportForm.vue?vue&type=template&id=78f4fa94&scoped=true&"
import script from "./newReportForm.vue?vue&type=script&lang=js&"
export * from "./newReportForm.vue?vue&type=script&lang=js&"
import style0 from "./newReportForm.vue?vue&type=style&index=0&id=78f4fa94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4fa94",
  null
  
)

export default component.exports